import React from "react";
import { Outlet } from "react-router-dom";

const ClientMenuLayout: React.FC = () => {
    return (
        <>
            <div >
                <Outlet />
            </div>
        </>
    )
};

export default ClientMenuLayout;